/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Import200ResponseDataInner } from './Import200ResponseDataInner'
import {
  Import200ResponseDataInnerFromJSON,
  Import200ResponseDataInnerFromJSONTyped,
  Import200ResponseDataInnerToJSON,
} from './Import200ResponseDataInner'

/**
 *
 * @export
 * @interface Import200Response
 */
export interface Import200Response {
  /**
   *
   * @type {boolean}
   * @memberof Import200Response
   */
  status: boolean
  /**
   *
   * @type {Array<Import200ResponseDataInner>}
   * @memberof Import200Response
   */
  data: Array<Import200ResponseDataInner>
}

/**
 * Check if a given object implements the Import200Response interface.
 */
export function instanceOfImport200Response(
  value: object
): value is Import200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function Import200ResponseFromJSON(json: any): Import200Response {
  return Import200ResponseFromJSONTyped(json, false)
}

export function Import200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Import200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(Import200ResponseDataInnerFromJSON),
  }
}

export function Import200ResponseToJSON(value?: Import200Response | null): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(Import200ResponseDataInnerToJSON),
  }
}
